import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="64"
    height="74"
    viewBox="0 0 64 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="14.2842" cy="16.3522" r="10.0103" fill="#CE8C0C" />
    <circle
      cx="14.2842"
      cy="15.2397"
      r="10.0103"
      fill="url(#paint0_linear_1982_56)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2844 22.4694C18.2772 22.4694 21.5141 19.2326 21.5141 15.2397C21.5141 11.2469 18.2772 8.01008 14.2844 8.01008C10.2916 8.01008 7.05476 11.2469 7.05476 15.2397C7.05476 19.2326 10.2916 22.4694 14.2844 22.4694ZM14.2844 23.5816C18.8915 23.5816 22.6263 19.8468 22.6263 15.2397C22.6263 10.6326 18.8915 6.89783 14.2844 6.89783C9.6773 6.89783 5.9425 10.6326 5.9425 15.2397C5.9425 19.8468 9.6773 23.5816 14.2844 23.5816Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5138 15.2397C21.5138 10.2346 17.297 8.32452 16.2306 7.73202C15.1642 7.13952 14.2842 6.89783 14.2842 6.89783C18.8913 6.89783 22.6261 10.6326 22.6261 15.2397C22.6261 19.8468 18.8913 23.5816 14.2842 23.5816C14.2842 23.5816 14.5625 23.5771 16.2306 23.0255C17.8987 22.4739 21.5138 19.2326 21.5138 15.2397Z"
      fill="#D89C00"
    />
    <path
      d="M13.8967 19.1327C12.9043 19.1327 11.949 18.8608 11.105 18.2688C10.5167 17.8563 9.83582 16.9249 9.83582 15.3459C9.83582 12.4164 11.3126 11.3473 14.2802 11.3473L18.5444 11.3473C18.5444 11.3473 18.6758 11.3405 18.713 11.3848C18.7599 11.4405 18.713 11.5724 18.713 11.5724L18.3117 12.8196C18.3117 12.8196 18.2586 12.9356 18.2035 12.9734C18.1389 13.0176 18.034 13.0158 18.034 13.0158H14.6874C12.7287 13.0158 11.564 13.1706 11.564 15.3459C11.564 16.0644 11.764 16.5757 12.1755 16.9089C12.8711 17.4721 14.2231 17.4961 15.0493 17.4154C15.0493 17.4154 15.3882 16.3109 15.444 16.1316C15.5094 15.9215 15.4808 15.8714 15.2768 15.8714C14.9822 15.8714 14.4525 15.8714 13.8904 15.8714C13.4964 15.8714 13.1094 15.6705 13.1094 15.1879C13.1094 14.7219 13.4695 14.4514 13.9631 14.4514C14.8178 14.4514 16.578 14.4514 16.9075 14.4514C17.3394 14.4514 17.7802 14.5141 17.5553 15.207L16.3643 18.8669C16.3643 18.8669 15.3914 19.1327 13.8967 19.1327Z"
      fill="#E2A60B"
    />
    <circle cx="13.8712" cy="58.9897" r="10.0103" fill="#CE8C0C" />
    <circle
      cx="13.8712"
      cy="57.8774"
      r="10.0103"
      fill="url(#paint1_linear_1982_56)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8713 65.107C17.8641 65.107 21.101 61.8701 21.101 57.8773C21.101 53.8845 17.8641 50.6477 13.8713 50.6477C9.8785 50.6477 6.64167 53.8845 6.64167 57.8773C6.64167 61.8701 9.8785 65.107 13.8713 65.107ZM13.8713 66.2192C18.4784 66.2192 22.2132 62.4844 22.2132 57.8773C22.2132 53.2702 18.4784 49.5354 13.8713 49.5354C9.26422 49.5354 5.52942 53.2702 5.52942 57.8773C5.52942 62.4844 9.26422 66.2192 13.8713 66.2192Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1006 57.8773C21.1006 52.8722 16.8838 50.9621 15.8174 50.3696C14.751 49.7771 13.871 49.5354 13.871 49.5354C18.4781 49.5354 22.2129 53.2702 22.2129 57.8773C22.2129 62.4844 18.4781 66.2192 13.871 66.2192C13.871 66.2192 14.1493 66.2147 15.8174 65.6631C17.4855 65.1115 21.1006 61.8701 21.1006 57.8773Z"
      fill="#D89C00"
    />
    <path
      d="M13.4834 61.7703C12.491 61.7703 11.5356 61.4984 10.6916 60.9064C10.1034 60.4939 9.42249 59.5625 9.42249 57.9835C9.42249 55.0541 10.8992 53.9849 13.8669 53.9849L18.1311 53.9849C18.1311 53.9849 18.2624 53.9781 18.2997 54.0224C18.3466 54.0782 18.2997 54.21 18.2997 54.21L17.8984 55.4572C17.8984 55.4572 17.8453 55.5732 17.7901 55.611C17.7256 55.6553 17.6207 55.6534 17.6207 55.6534H14.2741C12.3153 55.6534 11.1507 55.8082 11.1507 57.9835C11.1507 58.702 11.3506 59.2134 11.7622 59.5466C12.4578 60.1097 13.8098 60.1337 14.6359 60.053C14.6359 60.053 14.9749 58.9486 15.0307 58.7693C15.0961 58.5592 15.0674 58.509 14.8635 58.509C14.5688 58.509 14.0392 58.509 13.477 58.509C13.0831 58.509 12.696 58.3081 12.696 57.8256C12.696 57.3595 13.0561 57.089 13.5498 57.089C14.4044 57.089 16.1647 57.089 16.4942 57.089C16.9261 57.089 17.3669 57.1518 17.142 57.8446L15.951 61.5046C15.951 61.5046 14.9781 61.7703 13.4834 61.7703Z"
      fill="#E2A60B"
    />
    <circle cx="50.2178" cy="58.9897" r="10.0103" fill="#CE8C0C" />
    <circle
      cx="50.2178"
      cy="57.8774"
      r="10.0103"
      fill="url(#paint2_linear_1982_56)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.2179 65.107C54.2107 65.107 57.4475 61.8701 57.4475 57.8773C57.4475 53.8845 54.2107 50.6477 50.2179 50.6477C46.2251 50.6477 42.9882 53.8845 42.9882 57.8773C42.9882 61.8701 46.2251 65.107 50.2179 65.107ZM50.2179 66.2192C54.825 66.2192 58.5598 62.4844 58.5598 57.8773C58.5598 53.2702 54.825 49.5354 50.2179 49.5354C45.6108 49.5354 41.876 53.2702 41.876 57.8773C41.876 62.4844 45.6108 66.2192 50.2179 66.2192Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.4474 57.8773C57.4474 52.8722 53.2306 50.9621 52.1642 50.3696C51.0978 49.7771 50.2178 49.5354 50.2178 49.5354C54.8249 49.5354 58.5597 53.2702 58.5597 57.8773C58.5597 62.4844 54.8249 66.2192 50.2178 66.2192C50.2178 66.2192 50.4961 66.2147 52.1642 65.6631C53.8323 65.1115 57.4474 61.8701 57.4474 57.8773Z"
      fill="#D89C00"
    />
    <path
      d="M49.83 61.7703C48.8376 61.7703 47.8822 61.4984 47.0382 60.9064C46.4499 60.4939 45.769 59.5625 45.769 57.9835C45.769 55.0541 47.2458 53.9849 50.2135 53.9849L54.4776 53.9849C54.4776 53.9849 54.609 53.9781 54.6462 54.0224C54.6931 54.0782 54.6462 54.21 54.6462 54.21L54.245 55.4572C54.245 55.4572 54.1918 55.5732 54.1367 55.611C54.0721 55.6553 53.9672 55.6534 53.9672 55.6534H50.6206C48.6619 55.6534 47.4972 55.8082 47.4972 57.9835C47.4972 58.702 47.6972 59.2134 48.1088 59.5466C48.8044 60.1097 50.1564 60.1337 50.9825 60.053C50.9825 60.053 51.3214 58.9486 51.3772 58.7693C51.4426 58.5592 51.414 58.509 51.21 58.509C50.9154 58.509 50.3857 58.509 49.8236 58.509C49.4296 58.509 49.0426 58.3081 49.0426 57.8256C49.0426 57.3595 49.4027 57.089 49.8963 57.089C50.751 57.089 52.5113 57.089 52.8407 57.089C53.2727 57.089 53.7134 57.1518 53.4885 57.8446L52.2976 61.5046C52.2976 61.5046 51.3246 61.7703 49.83 61.7703Z"
      fill="#E2A60B"
    />
    <circle cx="49.2998" cy="16.1223" r="10.0103" fill="#CE8C0C" />
    <circle
      cx="49.2998"
      cy="15.0103"
      r="10.0103"
      fill="url(#paint3_linear_1982_56)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.2998 22.2399C53.2926 22.2399 56.5294 19.0031 56.5294 15.0102C56.5294 11.0174 53.2926 7.78059 49.2998 7.78059C45.307 7.78059 42.0701 11.0174 42.0701 15.0102C42.0701 19.0031 45.307 22.2399 49.2998 22.2399ZM49.2998 23.3521C53.9069 23.3521 57.6417 19.6173 57.6417 15.0102C57.6417 10.4031 53.9069 6.66833 49.2998 6.66833C44.6927 6.66833 40.9579 10.4031 40.9579 15.0102C40.9579 19.6173 44.6927 23.3521 49.2998 23.3521Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.5291 15.0102C56.5291 10.0051 52.3123 8.09503 51.2459 7.50253C50.1795 6.91002 49.2994 6.66833 49.2994 6.66833C53.9065 6.66833 57.6413 10.4031 57.6413 15.0102C57.6413 19.6173 53.9065 23.3521 49.2994 23.3521C49.2994 23.3521 49.5778 23.3476 51.2459 22.796C52.914 22.2444 56.5291 19.0031 56.5291 15.0102Z"
      fill="#D89C00"
    />
    <path
      d="M48.9119 18.9032C47.9195 18.9032 46.9641 18.6313 46.1201 18.0393C45.5318 17.6268 44.851 16.6954 44.851 15.1164C44.851 12.187 46.3277 11.1178 49.2954 11.1178L53.5596 11.1178C53.5596 11.1178 53.6909 11.111 53.7281 11.1553C53.775 11.2111 53.7281 11.3429 53.7281 11.3429L53.3269 12.5901C53.3269 12.5901 53.2737 12.7061 53.2186 12.7439C53.1541 12.7881 53.0491 12.7863 53.0491 12.7863H49.7025C47.7438 12.7863 46.5791 12.9411 46.5791 15.1164C46.5791 15.8349 46.7791 16.3462 47.1907 16.6794C47.8863 17.2426 49.2383 17.2666 50.0644 17.1859C50.0644 17.1859 50.4033 16.0814 50.4592 15.9021C50.5245 15.692 50.4959 15.6419 50.2919 15.6419C49.9973 15.6419 49.4677 15.6419 48.9055 15.6419C48.5115 15.6419 48.1245 15.441 48.1245 14.9584C48.1245 14.4924 48.4846 14.2219 48.9782 14.2219C49.8329 14.2219 51.5932 14.2219 51.9226 14.2219C52.3546 14.2219 52.7953 14.2847 52.5704 14.9775L51.3795 18.6374C51.3795 18.6374 50.4066 18.9032 48.9119 18.9032Z"
      fill="#E2A60B"
    />
    <circle cx="32.4925" cy="37.2631" r="10.0103" fill="#CE8C0C" />
    <circle
      cx="32.4925"
      cy="36.151"
      r="10.0103"
      fill="url(#paint4_linear_1982_56)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.4924 43.3806C36.4852 43.3806 39.7221 40.1438 39.7221 36.151C39.7221 32.1582 36.4852 28.9213 32.4924 28.9213C28.4996 28.9213 25.2628 32.1582 25.2628 36.151C25.2628 40.1438 28.4996 43.3806 32.4924 43.3806ZM32.4924 44.4929C37.0995 44.4929 40.8343 40.7581 40.8343 36.151C40.8343 31.5439 37.0995 27.8091 32.4924 27.8091C27.8853 27.8091 24.1505 31.5439 24.1505 36.151C24.1505 40.7581 27.8853 44.4929 32.4924 44.4929Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.7217 36.151C39.7217 31.1458 35.5049 29.2358 34.4385 28.6433C33.3721 28.0508 32.4921 27.8091 32.4921 27.8091C37.0992 27.8091 40.834 31.5439 40.834 36.151C40.834 40.7581 37.0992 44.4929 32.4921 44.4929C32.4921 44.4929 32.7704 44.4883 34.4385 43.9368C36.1066 43.3852 39.7217 40.1438 39.7217 36.151Z"
      fill="#D89C00"
    />
    <path
      d="M32.1044 40.044C31.112 40.044 30.1566 39.7721 29.3126 39.1801C28.7243 38.7676 28.0435 37.8362 28.0435 36.2572C28.0435 33.3278 29.5202 32.2586 32.4879 32.2586L36.7521 32.2586C36.7521 32.2586 36.8834 32.2518 36.9207 32.2961C36.9675 32.3519 36.9207 32.4837 36.9207 32.4837L36.5194 33.7309C36.5194 33.7309 36.4662 33.8469 36.4111 33.8847C36.3466 33.929 36.2416 33.9271 36.2416 33.9271H32.895C30.9363 33.9271 29.7716 34.0819 29.7716 36.2572C29.7716 36.9757 29.9716 37.4871 30.3832 37.8202C31.0788 38.3834 32.4308 38.4074 33.2569 38.3267C33.2569 38.3267 33.5958 37.2223 33.6517 37.0429C33.7171 36.8328 33.6884 36.7827 33.4844 36.7827C33.1898 36.7827 32.6602 36.7827 32.098 36.7827C31.7041 36.7827 31.317 36.5818 31.317 36.0992C31.317 35.6332 31.6771 35.3627 32.1707 35.3627C33.0254 35.3627 34.7857 35.3627 35.1151 35.3627C35.5471 35.3627 35.9878 35.4255 35.763 36.1183L34.572 39.7782C34.572 39.7782 33.5991 40.044 32.1044 40.044Z"
      fill="#E2A60B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1982_56"
        x1="14.2842"
        y1="5.22937"
        x2="14.2842"
        y2="25.2499"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1982_56"
        x1="13.8712"
        y1="47.8671"
        x2="13.8712"
        y2="67.8877"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1982_56"
        x1="50.2178"
        y1="47.8671"
        x2="50.2178"
        y2="67.8877"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1982_56"
        x1="49.2998"
        y1="5"
        x2="49.2998"
        y2="25.0206"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1982_56"
        x1="32.4925"
        y1="26.1407"
        x2="32.4925"
        y2="46.1613"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
    </defs>
  </SvgIcon>
));
